import { CardContent, Card as MuiCard, SxProps, Theme, Typography } from "@mui/material";

interface CardProps {
  children: React.ReactNode;
  variant?: "light" | "dark";
  sx?: SxProps<Theme>;
}

export const Card = ({ children, variant = "light", sx }: CardProps) => {
  const baseSx: SxProps<Theme> = {
    ...(variant === "dark"
      ? {
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }
      : {
          background: "white",
          boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
        }),
    padding: "20px",
    borderRadius: "15px",
    ...sx,
  };

  return (
    <MuiCard sx={baseSx}>
      <CardContent sx={cardContentSx}>{children}</CardContent>
    </MuiCard>
  );
};

Card.Title = ({ children, sx }: { children: React.ReactNode; sx?: SxProps<Theme> }) => {
  return (
    <Typography variant="h4" sx={{ ...titleSx, ...sx } as SxProps<Theme>}>
      {children}
    </Typography>
  );
};

const cardContentSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  alignItems: "center",
};

const titleSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "10px",
  fontSize: "1.2rem",
  color: "#1a1a2e",
  fontWeight: 600,
};
